import { Component, OnInit, inject } from '@angular/core';
import { CookieService } from '../../util/cookie.service';
import { FaroService } from '../../util/faro.service';

@Component({
  selector: 'black-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.css'],
  standalone: false
})
export class CookieConsentBannerComponent implements OnInit {
  private cookieService = inject(CookieService);
  private faroService = inject(FaroService);

  showBanner = false;
  isClosing = false;

  ngOnInit(): void {
    // Check if user has already set cookie preference
    const consent = this.cookieService.getCookie('cookie-consent');
    if (!consent) {
      // Show banner if no consent exists
      // Delay slightly for smooth transition on load
      setTimeout(() => {
        this.showBanner = true;
      }, 1000);
    }
  }

  onAccept(): void {
    // Set consent cookie for 365 days
    this.cookieService.setCookie('cookie-consent', 'accepted', {
      expires: 365,
      path: '/',
      sameSite: 'Lax',
      secure: window.location.protocol === 'https:'
    });
    
    // Initialize Faro now that consent is given
    this.faroService.initializeFaro();
    
    this.closeBanner();
  }

  onDecline(): void {
    // Set consent cookie for 365 days so they don't get asked again immediately
    this.cookieService.setCookie('cookie-consent', 'declined', {
      expires: 365,
      path: '/',
      sameSite: 'Lax',
      secure: window.location.protocol === 'https:'
    });
    
    this.closeBanner();
  }

  private closeBanner(): void {
    this.isClosing = true;
    // Wait for the slide-down fade-out animation to finish (300ms)
    setTimeout(() => {
      this.showBanner = false;
      this.isClosing = false;
    }, 300);
  }
}
